/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  fetchFormations({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_domaine_id/${userId}`)
        .then((response) => {
          commit('SET_FORMATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormateurs({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formateur_domaine_id/${userId}`)
        .then((response) => {
          commit('SET_FORMATEURS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
   addItem({ commit }, item) {
     return new Promise((resolve, reject) => {
       axios.post("https://trainingcenterback.codily.net/api/add_domaine", item)
         .then((response) => {
           commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
           resolve(response)
         })
         .catch((error) => { reject(error) })
     })
   },
  
  fetchUsers({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getdomaine")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUserNews({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/get_new_domaine")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_domaine_id/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`https://trainingcenterback.codily.net/api/destroy_domaine/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  updateRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/update_domaine/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  //////////////formateur
  fetchFormationsFormateur({ commit },obj) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_domaine_formateur_id/${obj.formateur}/${obj.formation}`)
        .then((response) => {
          console.log('domaineId',obj.formation)
          commit('SET_FORMATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDomainesFormateur({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_domaine_formateur_id/${userId}`)
        .then((response) => {
          console.log('userId',userId)
          console.log('dataaaaaaaaaa',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  //////////////candidat
  fetchFormationsCandidat({ commit },obj) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_domaine_candidat_id/${obj.formateur}/${obj.formation}`)
        .then((response) => {
          console.log('domaineId',obj.formation)
          commit('SET_FORMATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDomainesCandidat({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_domaine_candidat_id/${userId}`)
        .then((response) => {
          console.log('userId',userId)
          console.log('data',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
